import {cardTitle, tooltip} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import customInfoLabels from "../customInfoLabels";

const anexoFormularioStyle = {
  ...customCheckboxRadioSwitch,
  cardTitle,
  tooltip,
  ...customInfoLabels,
  ...buttonStyle,
  ...customSelectStyle,
  subComponent: {
    padding: 20,
    backgroundColor: "#edf8fb",
    boxShadow: "inset 0px 35px 10px -30px rgba(0,0,0,0.05), inset 0px -35px 10px -30px rgba(0,0,0,0.05)",

    "& label": {
      color: "#000000",
      fontWeight: "inherit",
    },

    "& p": {
      margin: 0
    },

    "& pre": {
      fontSize: "0.8em"
    }
  },
  resumo: {
    "& table": {
      width: "100%",
      "& td:first-child": {
        fontWeight: "bold"
      }
    }
  },
  acoes: {
    marginTop: 15,
    textAlign: "center",
    "& > *": {
      marginLeft: "5px",
      marginRight: "5px"
    }
  },
  dropzoneRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "25px",
    background: "#f6f9f7",
    marginBottom: 0,
    borderBottomLeftRadius: "0",
    borderBottomRightRadius: "0",
  },
  cardDropZone: {
    marginBottom: "0",
    borderBottomLeftRadius: "0",
    borderBottomRightRadius: "0",
  },
  cardAnexoRespostaFormulario: {
    "& .rt-thead": {
      display: "none"
    },
    marginTop: "0",
    borderTopLeftRadius: "0",
    borderTopRightRadius: "0",
  }
};

export default anexoFormularioStyle;
